function activeMenu(menuId)
{
	$("li#"+menuId).addClass("active");
	$("li#"+menuId).parents('li').addClass("active");
}
